import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { LoanRequests } from "./loanRequests.type";
const FormData = require("form-data");

const url = process.env.REACT_APP_CREDID_LOAN_URL;
const fileUploadUrl = process.env.REACT_APP_FILE_UPLOAD_URL;
const oneTimePurchaseUrl = process.env.REACT_APP_ONE_TIME_PURCHASE_URL;

const initialState: LoanRequests = {
  data: [],
  fileRecs: [],
  uploadProgress: 0,
  autoJobStatus: "start",
  epAutoJobStatus: "start",
  switchAutoJobStatus: "start",
  switchTitleFetchAutoJobStatus: "start",
};

const getLoanRequests = createAsyncThunk(
  "loanRequests/makeLoanRequestsApiCallStatus",
  async (arg: void, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/loan-request/get`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    const params = {
      dateFrom: new Date(),
      dateTo: new Date(),
      status: "All",
      source: "all",
    };
    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(url!.concat(pathname), params, { headers })
      );
      dispatch(loanRequestsActions.setData(response.data));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const addAdminLoanRequests = createAsyncThunk(
  "loanRequests/addLoanRequestsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/loan-request/add/admin`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(url!.concat(pathname), arg, { headers })
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const searchLoanRequests = createAsyncThunk(
  "loanRequests/searchLoanRequestsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/loan-request/get/v2`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    const params = {
      dateFrom: arg.from,
      dateTo: arg.to,
      status: arg.status,
      source: arg.source,
      query: arg.query,
      sortObj: arg.sortObj,
      filtering: arg.filtering,
      page: arg.page,
      limit: arg.limit,
      run: arg.run,
      from: arg.from,
      to: arg.to,
    };
    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(url!.concat(pathname), params, { headers })
      );
      dispatch(
        loanRequestsActions.setData({
          data: response.data?.loanRequests,
          total: response.data?.totalCount,
        })
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const getFileRecords = createAsyncThunk(
  "loanRequests/getFileRecordsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/loan-request/file-record`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    const params = {
      dateFrom: arg.dateFrom,
      dateTo: arg.dateTo,
    };
    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(url!.concat(pathname), params, { headers })
      );
      console.log("Success response from file rec :", response.data);
      dispatch(loanRequestsActions.setFileRecData(response.data));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const changeStatus = createAsyncThunk(
  "loanRequests/makeLoanRequestsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/loan-request/edit/change-status`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.put(url!.concat(pathname), arg, { headers })
      );
      dispatch(loanRequestsActions.setChangeStatus(arg));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const fileUpload = createAsyncThunk(
  "loanRequests/fileUploadApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/process/file/upload`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
      "Content-Type": "multipart/form-data",
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        dispatch(loanRequestsActions.setUploadProgress(percentCompleted));
      },
    };

    const form = new FormData();
    form.append("file", arg);
    try {
      /** make api call */
      const response = await axios.post(fileUploadUrl!.concat(pathname), form, {
        headers,
        ...config,
      });
      dispatch(loanRequestsActions.setChangeStatus(arg));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const fileParsed = createAsyncThunk(
  "loanRequests/fileParsedApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/process/file/upload`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
      "Content-Type": "multipart/form-data",
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        dispatch(loanRequestsActions.setUploadProgress(percentCompleted));
      },
    };

    const form = new FormData();
    form.append("file", arg);
    try {
      /** make api call */
      const response = await axios.post(fileUploadUrl!.concat(pathname), form, {
        headers,
        ...config,
      });
      dispatch(loanRequestsActions.setChangeStatus(arg));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const deleteFile = createAsyncThunk(
  "loanRequests/deleteFileApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/loan-request/delete/${arg}`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.delete(url!.concat(pathname), { headers })
      );
      console.log("Success response from delete file :", response.data);
      dispatch(loanRequestsActions.setChangeStatus(arg));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

// Process Jazzcash auto jobs
const processAutoJobs = createAsyncThunk(
  "loanRequests/processAutoJobsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/auto-jobs/process-payouts`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(oneTimePurchaseUrl!.concat(pathname), arg, { headers })
      );
      const status = arg.status;
      dispatch(
        loanRequestsActions.setProgressJobStatus(
          status === "start" ? "stop" : "start"
        )
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);
// Process Easypaisa auto jobs
const processEasypaisaAutoJobs = createAsyncThunk(
  "loanRequests/processAutoJobsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/auto-jobs/easypaisa/process-payouts`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(oneTimePurchaseUrl!.concat(pathname), arg, { headers })
      );
      const status = arg.status;
      console.log(
        "=== Setting EP Job Status as ",
        status === "start" ? "stop" : "start"
      );
      dispatch(
        loanRequestsActions.setProgressEasypaisaJobStatus(
          status === "start" ? "stop" : "start"
        )
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);
// Process Switch auto jobs
const processSwitchAutoJobs = createAsyncThunk(
  "loanRequests/processAutoJobsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/auto-jobs/switch/process-switch-payouts`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(oneTimePurchaseUrl!.concat(pathname), arg, { headers })
      );
      const status = arg.status;
      console.log(
        "=== Setting Switch Job Status as ",
        status === "start" ? "stop" : "start"
      );
      dispatch(
        loanRequestsActions.setProgressSwitchJobStatus(
          status === "start" ? "stop" : "start"
        )
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const refreshLoanRequest = createAsyncThunk(
  "loanRequests/makeLoanRequestsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const url = `${process.env.REACT_APP_CREDID_LOAN_URL}/loan-request/inquire`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(axios.post(url, arg, { headers }));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const deleteLoanRequest = createAsyncThunk(
  "loanRequests/makeLoanRequestsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const url = `${oneTimePurchaseUrl}/auto-jobs/switch-manually-delete/${arg._id}`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    try {
      /** make api call */
      const response = await trackPromise(axios.get(url, { headers }));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const processSwitchTitleFetchAutoJobs = createAsyncThunk(
  "loanRequests/processTitleFetchAutoJobsApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/auto-jobs/switch-title/process-switch-title-fetch`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(oneTimePurchaseUrl!.concat(pathname), arg, { headers })
      );
      const status = arg.status;
      console.log(
        "=== Setting Switch Title Fetch Job Status as ",
        status === "start" ? "stop" : "start"
      );
      dispatch(
        loanRequestsActions.setProgressSwitchFetchTitleJobStatus(
          status === "start" ? "stop" : "start"
        )
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);
// get all auto job status
const getJobStatus = createAsyncThunk(
  "loanRequests/getJobStatusApiCallStatus",
  async (arg: void, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/auto-jobs/set-status`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.get(oneTimePurchaseUrl!.concat(pathname), { headers })
      );

      const status = response?.data;

      dispatch(
        loanRequestsActions.setProgressJobStatus(
          status?.jcJobStatus?.status === "start" ? "stop" : "start"
        )
      );
      dispatch(
        loanRequestsActions.setProgressEasypaisaJobStatus(
          status?.epJobStatus?.status === "start" ? "stop" : "start"
        )
      );
      dispatch(
        loanRequestsActions.setProgressSwitchJobStatus(
          status?.switchJobStatus?.status === "start" ? "stop" : "start"
        )
      );
      dispatch(
        loanRequestsActions.setProgressSwitchFetchTitleJobStatus(
          status?.switchTitleFetchJobStatus?.status === "start"
            ? "stop"
            : "start"
        )
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

// get easypaisa auto job status
const getEasypaisaJobStatus = createAsyncThunk(
  "loanRequests/getJobStatusApiCallStatus",
  async (arg: void, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/auto-jobs/set-status/easypaisa`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };

    try {
      /** make api call */
      const response = await trackPromise(
        axios.get(oneTimePurchaseUrl!.concat(pathname), { headers })
      );
      console.log("Response >>> :", response);
      const status = response?.data?.status;
      dispatch(
        loanRequestsActions.setProgressEasypaisaJobStatus(
          status === "start" ? "stop" : "start"
        )
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const getLoanRequestsExport = createAsyncThunk(
  "loanRequests/makeLoanRequestsExportApiCallStatus",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(
          `${process.env.REACT_APP_CREDID_LOAN_URL}/loan-request/get/export`,
          {
            ...arg,
            status: arg.status,
            dateFrom: arg.from,
            dateTo: arg.to,
          },
          { headers }
        )
      );
      return response?.data?.loanRequests ?? [];
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const loanRequestsSlice = createSlice({
  name: "loanRequests",

  initialState: initialState,

  reducers: {
    setLoanRequests: (state, action) => {
      return { ...state, ...action.payload };
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setFileRecData: (state, action) => {
      state.fileRecs = action.payload;
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    setProgressJobStatus: (state, action) => {
      state.autoJobStatus = action.payload;
    },
    setProgressEasypaisaJobStatus: (state, action) => {
      state.epAutoJobStatus = action.payload;
    },
    setProgressSwitchJobStatus: (state, action) => {
      state.switchAutoJobStatus = action.payload;
    },
    setProgressSwitchFetchTitleJobStatus: (state, action) => {
      state.switchTitleFetchAutoJobStatus = action.payload;
    },
    resetUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    setChangeStatus: (state, action) => {
      const { status, id } = action.payload;
      state.data = state.data.map((r) => (r._id === id ? { ...r, status } : r));
    },
    reset: () => initialState,
    // Add here reducers
    // ...
  },
});

export const loanRequestsReducer = loanRequestsSlice.reducer;

export const loanRequestsActions = {
  ...loanRequestsSlice.actions,
  getLoanRequests,
  searchLoanRequests,
  getFileRecords,
  changeStatus,
  fileUpload,
  fileParsed,
  deleteFile,
  processAutoJobs,
  processEasypaisaAutoJobs,
  getJobStatus,
  getEasypaisaJobStatus,
  processSwitchAutoJobs,
  refreshLoanRequest,
  deleteLoanRequest,
  processSwitchTitleFetchAutoJobs,
  addAdminLoanRequests,
  getLoanRequestsExport,
};
